document.querySelectorAll('[data-photo-gallery]').forEach(gallery => {
  const track = gallery.querySelector('.photo-track');
  const thumbs = [...gallery.querySelectorAll('[data-photo-index]')];
  let index = 0;
  function show(next) {
    index = (next + thumbs.length) % thumbs.length;
    track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
  gallery.querySelector('.photo-controls').hidden = false;
  gallery.querySelector('.photo-thumbs').hidden = false;
  thumbs.forEach((button,i) => button.addEventListener('click',()=>show(i)));
  gallery.querySelector('[data-photo-prev]').addEventListener('click',()=>show(index-1));
  gallery.querySelector('[data-photo-next]').addEventListener('click',()=>show(index+1));
  track.addEventListener('keydown',event=>{
    if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  track.addEventListener('scroll',()=>{
    index = Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));
    gallery.querySelector('[data-photo-count]').textContent = `${index+1} / ${thumbs.length}`;
  },{passive:true});
  new ResizeObserver(()=>track.scrollTo({left:index*track.clientWidth,behavior:'instant'})).observe(track);
});
